module.exports = __webpack_public_path__ + "img/Step14.aaec5c93.png";